module.exports = __webpack_public_path__ + "gb-wls.4ac1e66da3767b97b582.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/gb-wls.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/gb-wls.svg
// module chunks = styles